// LEGACY: Uses SCSS with CSS modules. New code should use @metarouter-private/mr-mui components instead.
// LEGACY: Uses @ion/components. New code should use @metarouter-private/mr-mui components instead.
import React from 'react';
import pt from 'prop-types';

import { MrAppMain } from '@ion/components';
import { Typography, Stack } from '@metarouter-private/mr-mui';

import GeneralCard from 'app/settings/general';

import s from '../index.module.scss';

const Details = ({ me }) => {
  return (
    <MrAppMain className={s.main}>
      <GeneralCard title="Profile">
        <section>
          <Stack spacing={2.5}>
            <Typography variant="h3" mono>
              {me.name}
            </Typography>
            <Stack spacing={0.5}>
              <Typography variant="body1" color="text.secondary">
                email
              </Typography>
              <Typography variant="body1">{me.email}</Typography>
            </Stack>
          </Stack>
        </section>
      </GeneralCard>
    </MrAppMain>
  );
};

Details.propTypes = {
  me: pt.shape({
    name: pt.string,
    email: pt.string.isRequired,
  }).isRequired,
};

export default Details;
